import {
  LuBot, LuCalendarDays, LuChartColumn, LuChartLine, LuCirclePlus, LuImport, LuLayoutList,
  LuListFilter, LuOctagonX, LuPlug, LuRadar, LuSave, LuSend, LuSettings2, LuShare2,
  LuShieldAlert, LuTriangleAlert, LuCircleCheck,
} from 'react-icons/lu';
import { moduleTour as tour, OPTIONAL as opt } from '../defineTour';

// Landing-tab tour first; one tour per further tab below it.
const tours = [
  tour('social', '/social-media', 'social_media', [
    ['tabs', 'social.tabs', LuShare2],
    ['new', 'social.new', LuSend, opt],
    ['pipeline', 'social.pipeline', LuChartColumn, { placement: 'top', ...opt }],
  ]),
  tour('social_posts', '/social-media/posts', 'social_media', [
    ['list', 'social_posts.list', LuLayoutList, { placement: 'top' }],
    ['import', 'social_posts.import', LuImport],
    ['performance', 'social_posts.performance', LuChartLine, { placement: 'left', ...opt }],
  ]),
  tour('social_calendar', '/social-media/calendar', 'social_media', [
    ['month', 'social_calendar.month', LuCalendarDays],
    ['grid', 'social_calendar.grid', LuLayoutList, { placement: 'top', ...opt }],
    ['summary', 'social_calendar.summary', LuChartColumn, opt],
  ]),
  tour('social_listening', '/social-media/listening', 'social_media', [
    ['list', 'social_listening.list', LuRadar, { placement: 'top' }],
    ['status', 'social_listening.status', LuListFilter],
    ['new', 'social_listening.new', LuCirclePlus],
  ]),
  tour('social_crisis', '/social-media/crisis', 'social_media', [
    ['switch', 'social_crisis.switch', LuOctagonX],
    ['feed', 'social_crisis.feed', LuTriangleAlert, { placement: 'top' }],
    ['setup', 'social_crisis.setup', LuShieldAlert, { placement: 'left' }],
  ]),
  tour('social_connections', '/social-media/connections', 'social_media', [
    ['accounts', 'social_connections.accounts', LuPlug, { placement: 'top' }],
    ['status', 'social_connections.status', LuCircleCheck],
  ]),
  tour('social_settings', '/social-media/settings', 'social_media', [
    ['workspace', 'social_settings.workspace', LuSettings2],
    ['save', 'social_settings.save', LuSave],
    ['automations', 'social_settings.automations', LuBot, { placement: 'top', ...opt }],
  ]),
];

export default tours;
